$('document').ready(function () {




    // $(window).load(function () {
    //     $(".loader").fadeOut("slow", function () {
    //         $body.removeClass("loading");
    //     });
    //
    // });

    // if (document.getElementById('Target_Base_Range')) {


    // ===================mask=============
    $(".phone-number").mask('0000  00  0000');




    $(window).on('resize', function () {
        var win = $(this); //this = window
        if (win.width() > 1199) {
            $("header .nav-soci .nav-item").css("display", "block");
        } else {
            $("header .nav-soci .nav-item").css("display", "none");
        }
    });

//------------------------------- Menu -----------------------------------------
    $(".nav-soci i").click(function () {
        $(".nav-soci li").slideToggle("slow");
    });

    $(".nav-menu2 .nav-link").click(function () {
        if (!$(this).hasClass("active")) {
            $(".nav-menu2 .sub-menu").slideUp("slow");
            var navLink = $(".nav-menu2 .nav-link");
            navLink.removeClass("active");
            navLink.children("i").removeClass("fa-angle-up");
            navLink.children("i").addClass("fa-angle-down");
            $(this).siblings(".sub-menu").slideDown("slow");
            $(this).addClass("active");
            $(this).children("i").removeClass("fa-angle-down");
            $(this).children("i").addClass("fa-angle-up");
        } else{
            $(this).siblings(".sub-menu").slideUp("slow");
            $(this).removeClass("active");
        }

    });

    $(".overview-menu").click(function () {
        $(".nav-menu2").css("display", "none");
        $(this).css("display", "none");
    });

    $(".nav-menu2 .sub-menu").click(function () {
        $(".overview-menu").css("display", "none");
        $(".nav-menu2").css("display", "none");
    });

    $(".btn-menu").click(function () {
        $(".nav-menu2").css("display", "block");
        $(".overview-menu").css("display", "block");
    });

//------------------------------- scrolltotop -----------------------------------
    $('.scrolltotop').click(function () {
        $('html, body').animate({scrollTop: 0}, 500);
        return false;
    });

    $(window).scroll(function () {
        var elem = $('.nav-menu2');
        var top = $(this).scrollTop();
        if (top > 0) {
            elem.css('top', 0);

        }
        top = $(this).scrollTop();
        elem.css('top', 0);

        if ($(this).scrollTop() > 100) {
            $('.scrolltotop').fadeIn();
        } else {
            $('.scrolltotop').fadeOut();
        }

    });

// -------------------- Движение карусели слева на право ------------------------

    $('#Carousel-ERP_prj').each(function () {
        $('.carousel').carousel();

        var carousel = $(this).data('bs.carousel');
        carousel.pause();
        $(this).find('> .carousel-inner > .item:not(:first-child)').each(function () {
            $(this).prependTo(this.parentNode);
        });
        carousel.cycle = function (e) {
            if (!e) this.paused = false;
            if (this.interval) clearInterval(this.interval);
            this.options.interval
            && !this.paused
            && (this.interval = setInterval($.proxy(this.prev, this), this.options.interval))
            return this;
        };

        carousel.cycle();
    });

// ------------ Подключение bootstrap tooltip (всплывающая подсказка) -----------
    $('[data-toggle="tooltip"]').tooltip();

// ----------- Смена chevron в panel-heading ------------------------------------
    $(document).on('click', 'span.clickable', function (e) {
        var $this = $(this);
        if (!$this.hasClass('panel-collapsed')) {
            $this.addClass('panel-collapsed');
            $this.find('.Chevron').removeClass('fa-chevron-down').addClass('fa-chevron-up');
            // init ();
        } else {
            $this.removeClass('panel-collapsed');
            $this.find('.Chevron').removeClass('fa-chevron-up').addClass('fa-chevron-down');

        }
    });

// --- Автоматическое заполнение поля Company Name на странице регистрации компанни
    function AutoComplete() {
        var company_name = $('#CPP-company_name').val();
        $('#CPA-company_name').val(company_name);
    }

    $(function () {
        $('#CPP-company_name').focusout(AutoComplete);
    });

// ----------- Выбор всех чекбоксов при выборе чекбокса категории в SAP панели

    function selectGroup(e) {
        var target = $(e.target);
        var parents = target.parents();
        var inputCategory = $(this).find(".category input[type=checkbox]");
        var inputSubcategory = $(this).find(".subcategory input[type=checkbox]");
        var checkedCategory = inputCategory.is(":checked") ? true : false;
        var checkedSubCategory = inputSubcategory.is(":checked") ? true : false;
        var other = $(this).find(".form-input-txt");

        var suggestBtn = $(this).find(".suggest");
        if (suggestBtn.length) {
            if (target.hasClass("suggest")) {
                suggestBtn.html("Thank-you").removeClass("suggest").addClass('disabled');
                var suggestText = suggestBtn.siblings('input').val();
                if (suggestText) {
                    var data = {
                        skill_category_type_id: suggestBtn.attr('data-subcategory-id'),
                        suggest: suggestText
                    };
                    $.ajax({
                            headers: {
                                'X-CSRF-TOKEN': window.Laravel.csrfToken
                            },
                            url: "/api/skill/suggest",
                            data: data,
                            dataType: 'json',
                            type: 'POST'
                        }
                    ).done(function (result) {
                        var answer = result.answer;
                        if (answer) {
                            // suggestBtn.html("Thank-you").removeClass("suggest").addClass('disabled');
                        }
                    });
                }
            }
        }

        var category = Array.from(parents).filter((obj) => {
            return obj.classList.contains('category')
        }
    )
        ;
        if (category.length) {
            inputSubcategory.prop('checked', checkedCategory);
            // ----------- Отображение текстового поля при выборе чекбокса "Other"
            if (checkedCategory) {
                other.removeClass("hidden").addClass("show");
            } else {
                other.addClass("hidden").removeClass("show");
            }

        } else {
            var subcategory = Array.from(parents).filter((obj) => {
                return obj.classList.contains('subcategory')
            }
        )
            ;

            if (subcategory.length) {
                inputCategory.prop('checked', checkedSubCategory);
                // ----------- Отображение текстового поля при выборе чекбокса "Other"
                if (subcategory[0].innerText.replace(/\s+/g, '') == "Other") {
                    if (checkedSubCategory) {
                        other.removeClass("hidden").addClass("show");
                    } else {
                        other.addClass("hidden").removeClass("show");
                    }
                }
            }
        }

        if (!$(".skils").is(':checked')) {
            $(".error-skils").show();
        } else {
            $(".error-skils").hide();
        }

        // if (!$(".industry").is(':checked')) {
        //     $(".error-industry").show();
        // } else {
        //     $(".error-industry").hide();
        // }
    }

    $(function () {
        $(".group").click(selectGroup);
    });


// ----------- Отображает список штатов только для Австралии ------------------------
    var AUCity=["Adelaide","Brisbane", "Canberra","Darwin","Hobart", "Melbourne","Perth", "Sydney"];
    var NZcities=["Auckland", "Christchurch", "Wellington"];
    var AUoptions = [];
    var NZoptions = [];
    for(var i =0; i<AUCity.length; i++){
        AUoptions.push(new Option(AUCity[i]));
    }
    for(var i =0; i<NZcities.length; i++){
        NZoptions.push(new Option(NZcities[i]));
    }

    $("#country").change(function () {
        var country = $("#country").val();
        if(country=="1"){
            $("#CPA-city").html("").append(AUoptions);
            $("#MQVP-city").html("").append(AUoptions);
            $("#state").removeClass("hidden");
            $("#city").removeClass("hidden");
        }
        else if(country=="2"){
            $("#CPA-city").html("").append(NZoptions);
            $("#MQVP-city").html("").append(NZoptions);
            $("#city").removeClass("hidden");
            $("#state").addClass("hidden");
        }
        else if (country != '1') {
            $("#state").addClass("hidden");
            $("#city").addClass("hidden");
        }
        else if (country != '2') {
            $("#city").addClass("hidden");
        }
    });

// ------- Выбор всех чекбоксов на Home-page Candidate -> profile -> Search for Projects -------

    $("#all-item-searhc-prj:checkbox").click(function () {
        if ($("#all-item-searhc-prj").is(":checked")) {
            $(".item-searhc-prj input:checkbox").prop('checked', true);

        } else {
            $(".item-searhc-prj input:checkbox").prop('checked', false);
        }
    });

// -------------------- Выбор толко одного чекбокса из группы чекбоксов -----------------------
    $(".options-search").on("click", function () {
        var handler = function (event) {
            event = event || window.event;
            var target = event.target || event.srcElement;
            if (target.nodeType == 1 && target.nodeName.toLowerCase() == "input" && target.type == "checkbox" && target.checked) {
                var inputs = document.getElementsByTagName("input");
                for (var i = 0; inputs[i]; i++) {
                    if (inputs[i].type == "checkbox" && inputs[i] != target) {
                        inputs[i].checked = false;
                    }
                }
            }
        };
        if (document.addEventListener) {
            document.addEventListener('click', handler, false);
        } else if (document.attachEvent) {
            document.attachEvent('onclick', handler);
        }
    });
})
;

// ------------------------------------------
// $('.item-job').on("click", "button[name='apply']", function (event) {
//     a = $(event.delegateTarget).attr("id");
// });
//
// $('.item-job').on("click", "button[name='favourite']", function (event) {
//     a = $(event.delegateTarget).attr("id");
// });


//===================== Candidate Profile изменение надписей над табами===============================
$('.nav-tabs li').on("click", function (event) {
    var id = $(event.delegateTarget).attr("id");
    $(".def-text div").hide();
    var element = ".def-text ." + id;
    $(element).show();

});

//====================== Candidate Profile включение вкладки Search for Project при клике на Launch New Search=======

$('.search-for-profile ').on("click", function () {

    if (!$('#tabs #item-tab-2').hasClass("active in")) {
        $('.nav-tabs #projects').removeClass("active");
        $('#tabs #item-tab-1').removeClass("active in");

        $('.nav-tabs #search').addClass("active");
        $('#tabs #item-tab-2').addClass("active in");
    }
});

//=======================  Изменение надписи в календаре на странице LaunchNewProject и HomePage=================

$(function () {
    if ($(".bl-calendar").hasClass("launchNewProjectCalendar")) {
        $(".allPages").addClass("hidden");
        $(".forLaunchNewProject ").removeClass("hidden");
    }
    else {
        $(".forLaunchNewProject ").addClass("hidden");
        $(".allPages").removeClass("hidden");
    }
});

// ==================================for pay pages============================================================================

function a() {
    $body.addClass("loading");
}

if (document.getElementById('boxMemberships')) {
    $("#boxMemberships .setSubscr").click(function (e) {
        var data = {
            subscription_id: $("input[name='subscription_id']:checked").val(),
            promo: $("input[name='promo']").val()
        };
        // var win = window.open("", '_blank');
        // win.document.write("<body><style type='text\/css'>.loader {position:fixed; font-family: georgia; font-size:25px; color:#666666; z-index:1000; top:0; left:0; height:100%; width:100%; background: rgba( 255, 255, 255, .6 ) url('http://sampsonresume.com/labs/pIkfp.gif') 50% 50% no-repeat;} body.loading {overflow: hidden;}</style><div class='loader'>Please wait</div></body>");
        // win.document.body.classList.add("loading");
        $.ajax({
                headers: {
                    'X-CSRF-TOKEN': window.Laravel.csrfToken
                },
                url: '/pay/membership/subscription/add',
                data: data,
                dataType: 'json',
                type: 'POST',
                beforeSend: function () {
                    $body.addClass("loading");
                },
                complete: function () {
                    $body.removeClass("loading");
                }
            }
        ).done(function (result) {
            if (result) {
                // win.document.location = result.url;
                window.location.replace(result.url);
            }
        });
    });
}






